const isPro = Object.is(process.env.NODE_ENV, 'production')
 
console.log(isPro);
 
module.exports = {
  baseUrl: isPro ? '/' : '/api'
}


//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 1